import { __ } from '@wordpress/i18n';

export default function save(props){
    const {attributes } = props;
    const { blockId, productSizes } = attributes;


    return(
        <p>List elements</p>
    );

    
}

